import {collection, query, orderBy, limit, onSnapshot} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';

const COLLECTION = 'changelogs';

/**
 * Subscribe to the most recent changelog entries (for sidebar widget).
 * Returns an unsubscribe function.
 */
export function subscribeToRecentChangelogs(count, onData, onError) {
  const q = query(
    collection(db, COLLECTION),
    orderBy('publishedAt', 'desc'),
    limit(count)
  );

  return onSnapshot(q, (snapshot) => {
    const entries = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    onData(entries);
  }, onError);
}

/**
 * Subscribe to all changelog entries (for full page).
 * Returns an unsubscribe function.
 */
export function subscribeToAllChangelogs(onData, onError) {
  const q = query(
    collection(db, COLLECTION),
    orderBy('publishedAt', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const entries = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    onData(entries);
  }, onError);
}
